import React, { useEffect, useState, useCallback, useRef } from "react";
import noimage from '../../assets/images/Desktop placeholder.svg'
import styles from "./TentHouseService.module.css";
import {
  getTentHouseProviderServices,
  getTentHouseProviderAddedServices,
  syncTentHouseProviderServices,
  fetchserviceitemssecond,
} from "../../Apiservices/Auth/servers/fetchProviderData";
import { Dialog } from "primereact/dialog";
import config from "../../config";
import { CustomDatePicker } from "./CustomDatePicker";
import Tentpackagepage from "./tentpackage/Tentpackagepage";
// Extract ServiceRow component outside to prevent re-renders
const ServiceRow = React.memo(({ 
  row, 
  images, 
  currentIndex, 
  imageUrl, 
  onNextImage, 
  onPrevImage, 
  onOpenPopup,
  onInputChange,
  onImageLoad,
  onImageError
}) => {
  // Handle discount price change with validation
  const handleDiscountPriceChange = useCallback((value) => {
    const regularPrice = row.price;
    
    // Validate offer price is not greater than regular price
    if (value && regularPrice && parseFloat(value) > parseFloat(regularPrice)) {
      // Set error message
      onInputChange(row.id, "discount_price", value);
      return;
    }
    
    // Clear any existing error if validation passes
    onInputChange(row.id, "discount_price", value);
  }, [row.price, row.id, onInputChange]);

  return (
    <div className={styles.fullWidthRow}>
      <div className={styles.productSection}>
        <div className={styles.imageContainer}>
          <div className={styles.imageWrapper}>
            {images.length > 1 && (
              <button onClick={onPrevImage} className={styles.arrowLeft}>
                ◀
              </button>
            )}
            <img
              src={imageUrl}
              alt={row.service_name || "No image found"}
              className={styles.imagestyle}
              onClick={onOpenPopup}
              onLoad={onImageLoad}
              onError={onImageError}
            />
            {images.length > 1 && (
              <button onClick={onNextImage} className={styles.arrowRight}>
                ▶
              </button>
            )}
            {images.length > 1 && (
              <div className={styles.imageCounter}>
                {currentIndex + 1}/{images.length}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.singlecolumn}>
        <div className={styles.productInfo}>
          <div className={styles.productName}>
            {row.service_name}
          </div>
          
          {/* Show error message for price validation */}
          {row.errorMessage && (
            <div className={styles.errorMessage}>
              {row.errorMessage}
            </div>
          )}
          
          <div className={styles.useinputsdata}> 
            <div className={styles.pricingSection}>
              <div className={styles.priceField}>
                <label className={styles.fieldLabel}>Price</label>
                <PriceInput
                  value={row.price}
                  onChange={(e) => onInputChange(row.id, "price", e.target.value)}
                  placeholder="Enter price"
                />
              </div>

              <div className={styles.priceField}>
                <label className={styles.fieldLabel}>Offer price</label>
                <PriceInput
                  value={row.discount_price}
                  onChange={(e) => handleDiscountPriceChange(e.target.value)}
                  placeholder="Enter offer price"
                />
              </div>
            </div>
            
            <div className={styles.actionsSection}>
              {row.discount_price && (
                <div className={styles.dateField}>
                  <label className={styles.fieldLabel}>
                    Offer Ends On 
                    {!row.discount_valid_upto && (
                      <span className={styles.requiredStar}> *</span>
                    )}
                  </label>
                  <div className={styles.datePickerWithClear}>
                    <CustomDatePicker
                      value={row.discount_valid_upto} 
                      onChange={(date) => onInputChange(
                        row.id,
                        'discount_valid_upto',
                        date
                      )}
                      minDate={new Date().toISOString()}
                      placeholder="Select expiry date"
                      width="100%"
                    />
                  </div>
                  {/* Show error text for missing offer end date */}
                  {row.discount_price && !row.discount_valid_upto && (
                    <div className={styles.errorText}>
                      Offer end date is required when offer price is set
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

// Wrap PriceInput with React.memo to prevent unnecessary re-renders
const PriceInput = React.memo(({ value, onChange, placeholder, disabled = false }) => {
  const inputRef = useRef(null);
  
  const handleClear = useCallback(() => {
    onChange({ target: { value: '' } });
    // Focus back on input after clear
    setTimeout(() => inputRef.current?.focus(), 0);
  }, [onChange]);

  const handleChange = useCallback((e) => {
    const inputValue = e.target.value;
    if (inputValue === '' || /^\d+$/.test(inputValue)) {
      onChange(e);
    }
  }, [onChange]);

  return (
    <div className={styles.customInputWrapper}>
      <span className={styles.currencySymbol}>₹</span>
      <input
        ref={inputRef}
        type="text"
        value={value || ""}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={styles.customInput}
        inputMode="numeric"
        pattern="[0-9]*"
      />
      {value && (
        <button
          onClick={handleClear}
          className={styles.clearButtonInside}
          type="button"
        >
          ×
        </button>
      )}
    </div>
  );
});

function TentHouseService(props) {
  const [gridData, setGridData] = useState([]);
  const [filteredGridData, setFilteredGridData] = useState([]);
  const [filteredDataSecond, setfilteredDataSecond] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [hasChanges, setHasChanges] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [imageIndexMap, setImageIndexMap] = useState({});
  const [imageLoading, setImageLoading] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showPopupRowId, setShowPopupRowId] = useState(null); 
  const [saveCountdown, setSaveCountdown] = useState(0);
  const [autoSaveTimeout, setAutoSaveTimeout] = useState(null);
  const [saving, setIsSaving] = useState(false);

  const handleImageLoad = useCallback((serviceId) => {
    setImageLoading(prev => ({ ...prev, [serviceId]: false }));
  }, []);

  const handleImageError = useCallback((serviceId) => {
    setImageLoading(prev => ({ ...prev, [serviceId]: false }));
  }, []);

  const handleOpenPopup = useCallback((rowId) => setShowPopupRowId(rowId), []);
  const handleClosePopup = useCallback(() => setShowPopupRowId(null), []);

  // Fetch services data
  const resultedServicesFunc = useCallback(async () => {
    setLoading(true);
    try {
      const [tentHouseServices, addedServices, addedserviceitemssecond] = await Promise.all([
        getTentHouseProviderServices(),
        getTentHouseProviderAddedServices(),
        fetchserviceitemssecond()
      ]);

      const tempGridData = tentHouseServices.map((service) => {
        const existingService = addedServices.find(
          (added) => added.tent_house_service_id === service.id
        );
        return {
          id: service.id,
          tent_house_service_id: service.id,
          service_name: service.service_name,
          description: service.description,
          eventMappingId: existingService?.eventMappingId,
          price: existingService ? existingService.price : null,
          discount_price: existingService ? existingService.discount_price : null,
          discount_valid_upto: existingService?.discount_valid_upto ? new Date(existingService.discount_valid_upto) : null,
          toSave: false,
          alreadyMapped: !!existingService,
          errorMessage: "",
        };
      });

      tempGridData.sort((a, b) => {
        if (a.alreadyMapped === b.alreadyMapped) {
          return a.service_name.localeCompare(b.service_name);
        }
        return a.alreadyMapped ? -1 : 1;
      });
      console.log("setfilteredDataSecond",addedserviceitemssecond,addedServices,tentHouseServices)
      setfilteredDataSecond(addedserviceitemssecond || []);
      setGridData(tempGridData);
      setFilteredGridData(tempGridData);
    } catch (error) {
      console.error("Failed to fetch services:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const [popupImageIndex, setPopupImageIndex] = useState(0);

// Reset popup image index when dialog opens/closes
useEffect(() => {
  if (showPopupRowId !== null) {
    setPopupImageIndex(imageIndexMap[showPopupRowId] || 0);
  }
}, [showPopupRowId, imageIndexMap]);

// Get popup images for the selected row
const getPopupImages = useCallback(() => {
  if (!showPopupRowId) return [];
  
  const row = gridData.find(item => item.id === showPopupRowId);
  if (!row) return [];
  
  for (const category of filteredDataSecond.data || []) {
    const serviceWithImages = category.services?.find(
      service => service.id === row.tent_house_service_id
    );
    
    if (serviceWithImages?.gallery?.length > 0) {
      return serviceWithImages.gallery;
    }
  }
  
  return [];
}, [showPopupRowId, gridData, filteredDataSecond.data]);

// Get current popup image URL
const getPopupImageUrl = useCallback(() => {
  const images = getPopupImages();
  if (images.length === 0) return noimage;
  
  const currentImage = images[popupImageIndex];
  return currentImage?.id 
    ? `${config.API_BASE_URL}/gallery/download/${currentImage.id}`
    : noimage;
}, [getPopupImages, popupImageIndex]);

// Popup image navigation handlers
const handlePopupNextImage = useCallback(() => {
  const images = getPopupImages();
  if (images.length > 1) {
    setPopupImageIndex((popupImageIndex + 1) % images.length);
  }
}, [getPopupImages, popupImageIndex]);

const handlePopupPrevImage = useCallback(() => {
  const images = getPopupImages();
  if (images.length > 1) {
    setPopupImageIndex((popupImageIndex - 1 + images.length) % images.length);
  }
}, [getPopupImages, popupImageIndex]);
// const getPopupImageUrl = useCallback(() => {
//   if (!showPopupRowId) return noimage;
  
//   // Find the row data for the popup
//   const row = gridData.find(item => item.id === showPopupRowId);
//   if (!row) return noimage;
  
//   // Find the category and service that contains this row
//   for (const category of filteredDataSecond.data || []) {
//     const serviceWithImages = category.services?.find(
//       service => service.id === row.tent_house_service_id
//     );
    
//     if (serviceWithImages?.gallery?.length > 0) {
//       const images = serviceWithImages.gallery;
//       const currentIndex = imageIndexMap[row.id] || 0;
//       const currentImage = images[currentIndex];
      
//       if (currentImage?.id) {
//         return `${config.API_BASE_URL}/gallery/download/${currentImage.id}`;
//       }
//     }
//   }
  
//   return noimage;
// }, [showPopupRowId, gridData, filteredDataSecond.data, imageIndexMap]);
  useEffect(() => {
    resultedServicesFunc();
  }, [resultedServicesFunc]);

  useEffect(() => {
    if (filteredDataSecond.data && filteredDataSecond.data.length > 0 && selectedCategory === null) {
      setSelectedCategory(filteredDataSecond.data[0].id);
    }
  }, [filteredDataSecond.data, selectedCategory]);

  const handleAutoSave = useCallback(async () => {
    const changesToSave = gridData.filter((service) => service.toSave);
    
    if (hasErrors || changesToSave.length === 0) return;

    try {
      setIsSaving(true);
      await syncTentHouseProviderServices(changesToSave);
      
      setGridData(prevGridData => 
        prevGridData.map(item => ({
          ...item,
          toSave: changesToSave.some(change => change.id === item.id) ? false : item.toSave,
          changedFields: changesToSave.some(change => change.id === item.id) ? [] : item.changedFields
        }))
      );
      
    } catch (error) {
      console.error("Error auto-saving changes:", error);
    } finally {
      setIsSaving(false);
    }
  }, [gridData, hasErrors]);

  const handleInputChange = useCallback((id, field, value) => {
    // Clear existing timeout immediately
    if (autoSaveTimeout) {
      clearTimeout(autoSaveTimeout);
      setAutoSaveTimeout(null);
    }

    setGridData(prevGridData => {
      const updatedGridData = prevGridData.map((item) => {
        if (item.id === id) {
          const updatedItem = {
            ...item,
            [field]: value,
            toSave: true,
            changedFields: [...new Set([...(item.changedFields || []), field])],
            errorMessage: "",
          };
          
          // If price is being cleared, also clear discount_price and discount_valid_upto
          if (field === "price" && (value === "" || value === null)) {
            updatedItem.discount_price = null;
            updatedItem.discount_valid_upto = null;
            updatedItem.changedFields = [...new Set([
              ...updatedItem.changedFields, 
              "discount_price", 
              "discount_valid_upto"
            ])];
          }
          
          // Validation logic
          if (
            field === "discount_price" &&
            value !== "" &&
            value !== null &&
            updatedItem.price &&
            Number(value) > Number(updatedItem.price)
          ) {
            updatedItem.errorMessage = "Offer price must be less than or equal to regular price.";
          }
          
          return updatedItem;
        }
        return item;
      });

      return updatedGridData;
    });

    const delay = 2000;
    setSaveCountdown(delay / 1000);
    
    // Start countdown
    const countdownInterval = setInterval(() => {
      setSaveCountdown(prev => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    // Set new timeout
    const timeoutId = setTimeout(() => {
      clearInterval(countdownInterval);
      setSaveCountdown(0);
      handleAutoSave();
    }, delay);

    setAutoSaveTimeout(timeoutId);
  }, [autoSaveTimeout, handleAutoSave]);

  const handleSearch = useCallback((e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
  }, []);

  // Image navigation handlers
  const handleNextImage = useCallback((rowId, images, currentIndex) => {
    if (images.length > 1) {
      setImageIndexMap(prev => ({
        ...prev,
        [rowId]: (currentIndex + 1) % images.length,
      }));
    }
  }, []);

  const handlePrevImage = useCallback((rowId, images, currentIndex) => {
    if (images.length > 1) {
      setImageIndexMap(prev => ({
        ...prev,
        [rowId]: (currentIndex - 1 + images.length) % images.length,
      }));
    }
  }, []);

  // Sync filtered data with grid data and search term
  useEffect(() => {
    if (searchTerm) {
      const filtered = gridData.filter(
        (service) =>
          service.service_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          service.description?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredGridData(filtered);
    } else {
      setFilteredGridData(gridData);
    }
  }, [gridData, searchTerm]);

  // Track changes and errors
  useEffect(() => {
    setHasChanges(gridData.some((service) => service.toSave));
    setHasErrors(gridData.some((service) => service.errorMessage));
  }, [gridData]);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (autoSaveTimeout) {
        clearTimeout(autoSaveTimeout);
      }
    };
  }, [autoSaveTimeout]);
const enhancedCategories = [
  {
    id: 'package',
    name: 'Package',
    category_image: null,
    services: [] // Empty services for now
  },
  ...(filteredDataSecond.data || [])
];
  // Memoized service rendering - FIXED: Removed useCallback from inside
  const renderServices = useCallback((category) => {
    const matchedServices = filteredGridData.filter((row) => {
      const isInCategory = category.services?.some(
        (service) => service.id === row.tent_house_service_id
      );
      const matchesSearch = row.service_name?.toLowerCase().includes(searchTerm);
      return isInCategory && matchesSearch;
    });

    if (matchedServices.length === 0) {
      return (
        <div key={category.id} className={styles.noServicesMessage}>
          No services found in this category
        </div>
      );
    }

    return (
      <div key={category.id} className={styles.servicesSection}>
        {matchedServices.map((row) => {
          const serviceWithImages = category.services
            ?.find(service => service.id === row.tent_house_service_id);

          const images = serviceWithImages?.gallery || [];
          const currentIndex = imageIndexMap[row.id] || 0;
          const currentImage = images[currentIndex];
          const imageUrl = currentImage?.id 
            ? `${config.API_BASE_URL}/gallery/download/${currentImage.id}`
            : noimage;

          return (
            <ServiceRow 
              key={row.id}
              row={row}
              images={images}
              currentIndex={currentIndex}
              imageUrl={imageUrl}
              onNextImage={() => handleNextImage(row.id, images, currentIndex)}
              onPrevImage={() => handlePrevImage(row.id, images, currentIndex)}
              onOpenPopup={() => handleOpenPopup(row.id)}
              onInputChange={handleInputChange}
              onImageLoad={() => handleImageLoad(row.id)}
              onImageError={() => handleImageError(row.id)}
            />
          );
        })}
      </div>
    );
  }, [
    filteredGridData, 
    searchTerm, 
    imageIndexMap, 
    handleInputChange, 
    handleOpenPopup, 
    handleImageLoad, 
    handleImageError,
    handleNextImage,
    handlePrevImage
  ]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <main className={styles.mainContent}>
      <div className={styles.searchWidget}>
        <label className={styles.searchLabel}>Item list</label>
        <input
          type="text"
          placeholder="Search Items"
          value={searchTerm}
          onChange={handleSearch}
          className={styles.searchInput}
        />
      </div>

      <div className={styles.horizontalScrollWrapper}>
        <div className={styles.gridTable}>
          <div className={styles.verticalScrollWrapper}>
            <div className={styles.twoColumnLayout}>
              {/* Left Navbar - Categories */}
              <div className={styles.categoryNavbar}>
                {enhancedCategories.map((category) => {
                  const matchedServicesforcategory = filteredGridData.filter((row) => {
                    const isInCategory = category.services?.some(
                      (service) => service.id === row.tent_house_service_id
                    );
                    const matchesSearch = row.service_name?.toLowerCase().includes(searchTerm);
                    return isInCategory && matchesSearch;
                  });
                  
                   if (matchedServicesforcategory.length === 0 && category.id !== 'package') return null;
                  
                  return (
                    <div
                      key={category.id}
                      className={`${styles.categoryItem} ${
                        selectedCategory === category.id ? styles.activeCategory : ""
                      }`}
                      onClick={() => setSelectedCategory(category.id)}
                    >
                      <div className={styles.imagewithtextintent}>
                        <img
                          src={
                            category?.category_image?.id
                              ? `${config.API_BASE_URL}/gallery/download/${category.category_image.id}`
                              : category?.services?.[0]?.gallery?.[0]?.id
                                ? `${config.API_BASE_URL}/gallery/download/${category.services[0].gallery[0].id}`
                                : noimage
                          }
                          alt={category.name || "No image found"}
                          className={styles.categoryimagestyle}
                        />
                        <div className={styles.categoryName}>
                          {category.name} 
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Right Content - Services */}
              <div className={styles.servicesContent}>
                <div>
                  <div style={{color:"#26B8E3"}}>
                    {hasErrors && "Please resolve all errors"}
                    {saving && "Saving changes..."}
                    {!hasErrors && !saving && hasChanges && `Changes will save in ${saveCountdown}s`}
                    {!hasErrors && !saving && !hasChanges && "All changes saved"}
                  </div>
                </div>
                {selectedCategory === 'package'?
                (<> <Tentpackagepage /> </>):
                (
                <>
                {filteredDataSecond.data
                  ?.filter((category) => category.id === selectedCategory)
                  .map((category) => {
                    const matchedServicesforcategory = filteredGridData.filter((row) => {
                      const isInCategory = category.services?.some(
                        (service) => service.id === row.tent_house_service_id
                      );  
                      const matchesSearch = row.service_name
                        ?.toLowerCase()
                        .includes(searchTerm.toLowerCase());
                      return isInCategory && matchesSearch;
                    });

                    return (
                      <div key={category.id} className={styles.selectedcategoryarea}>
                        <div className={styles.selectedcategoryareaheadder}> 
                          <span className={styles.selectedcategoryname}>{category.name}</span>
                          <span>({matchedServicesforcategory.length})</span>
                        </div> 
                        <span>Please enter price, offer details below.</span>
                      </div>
                    );
                  })}

                <div className={styles.gridDatafor_services}>
                  {filteredDataSecond.data?.map((category) => {
                    if (selectedCategory !== category.id) return null;
                    return renderServices(category);
                  })}
                
                </div>
                  </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Preview Dialog */}
     <Dialog
  visible={showPopupRowId !== null}
  onHide={handleClosePopup}
  header={(() => {
    const row = gridData.find(item => item.id === showPopupRowId);
    return row ? row.service_name : "Image Preview";
  })()}
  className={styles.dialogBox}
  modal
  dismissableMask
>
  {showPopupRowId && (
    <div className={styles.popupContainer}>
      {getPopupImages().length > 1 && (
        <button onClick={handlePopupPrevImage} className={styles.popupArrowLeft}>
          ◀
        </button>
      )}
      
      <img
        src={getPopupImageUrl()}
        alt="Preview"
        className={styles.popupImage}
        onError={(e) => {
          e.target.src = noimage;
        }}
      />
      
      {getPopupImages().length > 1 && (
        <button onClick={handlePopupNextImage} className={styles.popupArrowRight}>
          ▶
        </button>
      )}
      
      {getPopupImages().length > 1 && (
        <div className={styles.popupImageCounter}>
          {popupImageIndex + 1}/{getPopupImages().length}
        </div>
      )}
    </div>
  )}
</Dialog>
    </main>
  );
}

export default React.memo(TentHouseService);